import React, { Component } from "react";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import { Container, Row, Col, Modal, OverlayTrigger, Tooltip, Form, Spinner, Badge, Button } from "react-bootstrap";
import * as XLSX from 'xlsx';
import MultiSelect from "react-multi-select-component";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import StudentProfileModal from './StudentProfileModal';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import AssignTestModal from "./AssignTestModal";
import "./_admissionForms.scss";
import { triggerSms } from "../../utils/smsHelper";
import { triggerEmail } from "../../utils/emailHelper";
import SendSMSModal from "./SendSMSModal";
import SendEmailModal from "./SendEmailModal";
import SendWhatsAppModal from "./SendWhatsAppModal";
import AdmissionDetailedResultPdf from "../admissionprocess/AdmissionDetailedResultPdf";
import AdmissionBreadcrumb from "./AdmissionBreadcrumb";
import DynamicAdmissionModal from "../newAdmissionForm/DynamicAdmissionModal";
import BulkAdmitModal from "./BulkAdmitModal";
import DateBlock from "../home_bck/DateBlock";
// ── Constants ───────────────────────────────────────────
const STATUS_OPTIONS = [
  { label: "Exam Completed", value: "completed" },
  { label: "Exam Assigned", value: "assigned" },
  { label: "Enquired", value: "" },
  { label: "Student Admitted", value: "admitted" },
];

const TIMEFRAME_OPTIONS = [
  { label: "Today", value: 1 },
  { label: "Yesterday", value: 2 },
  { label: "Last 7 Days", value: 7 },
  { label: "Last 30 Days", value: 30 },
  { label: "Overall", value: 0 },
  { label: "Custom Range", value: -1 }
];

// ── GraphQL Queries ───────────────────────────────────────
const GET_FORM_FIELDS_FOR_PRINT = gql`
  query ($form_id: Int!, $institute_id: Int) {
    getEnquiryFormFields(form_id: $form_id, institute_id: $institute_id) {
      id
      field_name
      field_key
      field_type
      order_no
    }
  }
`;

const GET_PAGINATED_ENQUIRY_SUBMISSIONS = gql`
  query ($form_ids: [Int], $institute_id: Int, $page: Int, $limit: Int, $search: String, $branch_ids: [String], $status: [String], $days: Int, $startDate: String, $endDate: String) {
    getPaginatedEnquirySubmissions(
      form_ids: $form_ids
      institute_id: $institute_id
      page: $page
      limit: $limit
      search: $search
      branch_ids: $branch_ids
      status: $status
      days: $days
      startDate: $startDate
      endDate: $endDate
    ) {
      totalCount
      totalCompleted
      totalAssigned
      totalAdmitted
      submissions {
        id
        enquiry_form_id
        student_name
        student_mobile
        student_email
        gender
        dob
        institute_id
        branch_id
        enquiry_course_id
        class_id
        enquiry_courses
        estatus
        extra_details
        inserted_at
        test_status
        test_score
        total_marks
        admission_test_id
        admitted_status
        username
        password
        is_admitted
        admission_no
        roll_no
      }
    }
  }
`;

const GET_ASSIGNED_TEST = gql`
  query ($enquiry_form_master_id: Int!) {
    getAssignedTest(enquiry_form_master_id: $enquiry_form_master_id) {
      id
      admission_test_id
      username
      password
      estatus
    }
  }
`;

const GET_ADMISSION_TEST_SESSION = gql`
  query ($enquiry_form_master_id: Int!, $admission_test_id: Int!) {
    getAdmissionTestSession(
      enquiry_form_master_id: $enquiry_form_master_id
      admission_test_id: $admission_test_id
    ) {
      id
      is_completed
      total_marks_gained
      total_marks
      subject_analytics {
        subject_id
        subject_name
        correct
        wrong
        unattempted
        marks_gained
        total_marks
      }
    }
  }
`;

const GET_ENQUIRY_FORM_FIELDS = gql`
  query ($form_id: Int!) {
    getEnquiryFormFields(form_id: $form_id) {
      id
      field_name
      options
    }
  }
`;

const ASSIGN_ADMISSION_TEST_AUTO = gql`
  mutation ($enquiry_form_master_id: Int!, $institute_id: Int!, $branch_id: String!, $inserted_by: Int) {
    assignAdmissionTestAuto(
      enquiry_form_master_id: $enquiry_form_master_id,
      institute_id: $institute_id,
      branch_id: $branch_id,
      inserted_by: $inserted_by
    ) {
      id
      username
      password
    }
  }
`;

const MARK_AS_ADMITTED = gql`
  mutation ($enquiry_form_master_id: Int!, $admission_test_id: Int, $class_id: Int, $section_id: Int, $exam_id: Int) {
    markAsAdmitted(
      enquiry_form_master_id: $enquiry_form_master_id,
      admission_test_id: $admission_test_id,
      class_id: $class_id,
      section_id: $section_id,
      exam_id: $exam_id
    )
  }
`;

const ASSIGN_ADMISSION_TESTS_BULK = gql`
  mutation ($enquiry_form_master_ids: [Int]!, $institute_id: Int!, $branch_id: String!, $inserted_by: Int) {
    assignAdmissionTestsBulk(
      enquiry_form_master_ids: $enquiry_form_master_ids,
      institute_id: $institute_id,
      branch_id: $branch_id,
      inserted_by: $inserted_by
    ) {
      id
    }
  }
`;

const GET_ENQUIRY_FORMS = gql`
  query ($institute_id: Int!, $branch_id: String!) {
    getEnquiryForms(institute_id: $institute_id, branch_id: $branch_id) {
      id
      form_name
    }
  }
`;

const GET_ADMISSION_TESTS = gql`
  query ($institute_id: Int!, $branch_id: String!) {
    getAdmissionTests(institute_id: $institute_id, branch_id: $branch_id) {
      id
    }
  }
`;

class AllEnquiryStudentsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      students: [],
      filteredStudents: [],
      loader: true,
      error: "",
      searchQuery: "",
      selectedBranches: [],
      selectedStatus: STATUS_OPTIONS,
      selectedFormIds: [],
      availableForms: [],

      // Pagination & KPIs
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      totalCompleted: 0,
      totalAssigned: 0,
      totalAdmitted: 0,

      // Assign test modal
      showAssignModal: false,
      selectedStudent: null,

      // Student detail modal
      showDetailModal: false,
      detailStudent: null,

      // SMS modal
      showSMSModal: false,
      smsStudent: null,

      // Email modal
      showEmailModal: false,
      emailStudent: null,

      // WhatsApp modal
      showWAModal: false,
      waStudent: null,

      // Result Modal
      showResultModal: false,
      resultStudent: null,
      resultSessionData: null,
      loadingResult: false,

      // Admit Modal
      showAdmitModal: false,
      admitStudent: null,

      // Bulk Actions
      selectedStudentIds: [],
      showBulkAdmitModal: false,
      bulkAssigning: false,

      // Export & Print
      exporting: false,
      printing: false,

      // Timeframe Filters — default to Custom with a 1-week window
      // (today - 7 days → today) so the DateBlock display matches the
      // dates sent to the backend.
      selectedTimeframe: TIMEFRAME_OPTIONS.find(o => o.value === -1),
      startDate: (() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      })(),
      endDate: (() => {
        const d = new Date();
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      })(),

      // Exams detection
      hasExams: false, // Hide exam-related UI until we've checked
      hasExamsLoaded: false,
    };
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  componentDidMount() {
    // Branch comes from the header (NavbarOne) — re-scope when it changes.
    this.offBranchScope = onBranchScopeChange(() => this.initBranches());
    this.initBranches();
    this.checkExamsAvailability();
  }

  checkExamsAvailability = async () => {
    try {
      const instituteId =
        parseInt(Cookies.get("institutionid")) ||
        parseInt(Cookies.get("institution_id")) ||
        0;

      const response = await this.props.client.query({
        query: GET_ADMISSION_TESTS,
        variables: {
          institute_id: instituteId,
          branch_id: "" // Check for all branches
        },
        fetchPolicy: 'network-only'
      });
      const tests = response.data.getAdmissionTests || [];
      const hasExams = tests.length > 0;
      this.setState(prevState => {
        let newSelectedStatus = prevState.selectedStatus;
        if (!hasExams) {
          newSelectedStatus = prevState.selectedStatus.filter(o => o.value === "admitted" || o.value === "");
        }
        return { hasExams, hasExamsLoaded: true, selectedStatus: newSelectedStatus };
      }, () => {
        // If we filtered the status and we've already fetched students, we might want to refetch,
        // but typically this happens so fast during mount that it's transparent.
      });
    } catch (error) {
      console.error("Error checking exams availability:", error);
      this.setState({ hasExamsLoaded: true });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Only handle branch re-init if globals change
    const branches = this.props.globals && this.props.globals.globalBranches;
    const prevBranches = prevProps.globals && prevProps.globals.globalBranches;
    if (
      branches &&
      branches !== prevBranches &&
      this.state.selectedBranches.length === 0
    ) {
      this.initBranches();
    }
  }

  handlePageSizeChange = (e) => {
    const val = parseInt(e.target.value);
    this.setState({
      pageSize: val,
      currentPage: 1
    }, () => this.fetchStudents());
  }

  // selectedBranches simply mirrors the header's branch scope (NavbarOne) — this tab
  // has no branch picker of its own.
  initBranches = () => {
    const branches = scopeBranches(this.props.globals?.globalBranches || []);
    if (branches.length > 0) {
      const selected = branches.map((b) => ({ label: b.branch_name, value: b.id }));
      this.setState({ selectedBranches: selected }, () => {
        this.fetchForms(selected);
      });
    }
  };

  fetchForms = async (branches) => {
    try {
      const instituteId = parseInt(Cookies.get("institutionid")) || 0;
      let allForms = [];

      for (const branch of branches) {
        const result = await this.props.client.query({
          query: GET_ENQUIRY_FORMS,
          variables: { institute_id: instituteId, branch_id: String(branch.value) },
          fetchPolicy: "network-only",
        });
        const forms = result.data.getEnquiryForms || [];
        allForms = [...allForms, ...forms];
      }

      // Deduplicate forms by id
      const uniqueFormsMap = new Map();
      allForms.forEach(f => uniqueFormsMap.set(f.id, f));
      
      const availableForms = Array.from(uniqueFormsMap.values()).map(f => ({
        label: f.form_name,
        value: f.id
      }));

      this.setState({ availableForms }, () => this.fetchStudents());
    } catch (err) {
      console.error("Error fetching forms:", err);
      this.fetchStudents(); // Proceed to fetch students anyway
    }
  };

  fetchAllFilteredStudents = async () => {
    const { formId } = this.props;
    const { searchQuery, selectedBranches, selectedStatus } = this.state;

    if (selectedBranches.length === 0 || selectedStatus.length === 0) {
      return [];
    }

    const maxStatusCount = this.state.hasExams ? STATUS_OPTIONS.length : 2;
    const statusToSend = selectedStatus.length === maxStatusCount ? [] : selectedStatus.map(s => s.value);

    const variables = {
      form_ids: this.state.selectedFormIds.map(f => parseInt(f.value)),
      page: 1,
      limit: 99999, // High limit for export
      search: searchQuery || "",
      branch_ids: selectedBranches.map(b => String(b.value)),
      status: statusToSend,
    };
    if (this.state.selectedTimeframe.value >= 0) {
      variables.days = this.state.selectedTimeframe.value;
    }
    if (this.state.selectedTimeframe.value === -1) {
      if (this.state.startDate) variables.startDate = this.state.startDate;
      if (this.state.endDate)   variables.endDate   = this.state.endDate;
    }

    try {
      const result = await this.props.client.query({
        query: GET_PAGINATED_ENQUIRY_SUBMISSIONS,
        variables,
        fetchPolicy: "network-only",
      });

      const paginatedData = result.data.getPaginatedEnquirySubmissions;
      const submissions = paginatedData ? paginatedData.submissions : [];

      return await this.processSubmissions(submissions);
    } catch (err) {
      console.error("Error fetching all students:", err);
      return [];
    }
  };

  processSubmissions = async (submissions) => {
    const { formId } = this.props;

    // Fetch form fields to get Course Name options for mapping
    // Since we are showing all forms, we might not have a single formId.
    // If we have a formId prop we use it, otherwise we skip standard option mapping and rely on extra_details.
    const fields = [];
    if (formId && parseInt(formId) > 0) {
      try {
        const fieldsResult = await this.props.client.query({
          query: GET_ENQUIRY_FORM_FIELDS,
          variables: { form_id: parseInt(formId) },
          fetchPolicy: "network-only",
        });
        if (fieldsResult.data.getEnquiryFormFields) {
          fields.push(...fieldsResult.data.getEnquiryFormFields);
        }
      } catch (err) { console.error(err); }
    }

    // Create a map of Field ID -> Field Label
    const fieldIdMap = {};
    fields.forEach(f => {
      fieldIdMap[f.id] = f.field_name;
    });

    const courseField = fields.find(f => {
      const lbl = (f.field_name || "").toLowerCase().replace(/_/g, ' ').trim();
      return lbl === "course name" || lbl === "enquiry class";
    });
    const courseOptions = courseField ? courseField.options || [] : [];

    // Get branch lookup from globals
    const branches = (this.props.globals && this.props.globals.globalBranches) || [];

    // Map dynamic fields and static names
    return submissions.map((student) => {
      let extra = {};
      try {
        if (student.extra_details) {
          const rawExtra = typeof student.extra_details === 'string' ? JSON.parse(student.extra_details) : student.extra_details;

          if (rawExtra && !Array.isArray(rawExtra)) {
            Object.entries(rawExtra).forEach(([key, value]) => {
              const label = fieldIdMap[key] || key;
              extra[label] = value;
            });
          } else if (Array.isArray(rawExtra)) {
            rawExtra.forEach(item => {
              const id = item.enquiry_field_id || item.id;
              const label = item.label || item.field_name || fieldIdMap[id] || id;
              extra[label] = item.value || item.field_value;
            });
          } else {
            extra = rawExtra;
          }
        }
      } catch (e) {
        extra = student.extra_details || {};
      }

      const branch = branches.find(b => parseInt(b.id) === parseInt(student.branch_id));
      const branchName = branch ? branch.branch_name : "N/A";

      let courseName = student.enquiry_courses || "";
      if (!courseName) {
        const courseOpt = courseOptions.find(o => parseInt(o.value) === parseInt(student.enquiry_course_id));
        if (courseOpt) {
          courseName = courseOpt.label;
        } else {
          courseName = extra["Enquiry Class"] || extra["Course Name"] || extra["course_name"] || extra["Course"] || extra["Class"] || extra["Grade"] || "";
        }
      }

      const formName = this.state.availableForms.find(f => parseInt(f.value) === parseInt(student.enquiry_form_id))?.label || "Enquiry Form";

      // Search for specific labels in extra keys
      const getVal = (labels) => {
        for (const lbl of labels) {
          const foundKey = Object.keys(extra).find(k => k.toLowerCase().replace(/_/g, ' ').trim() === lbl.toLowerCase());
          if (foundKey && extra[foundKey]) return extra[foundKey];
        }
        return "—";
      };

      const fatherName = getVal(["father's name", "father name", "guardian name", "parent name"]);
      const fatherMobile = getVal(["father's mobile", "father mobile", "father phone", "father's phone", "father contact"]);
      const motherName = getVal(["mother's name", "mother name"]);
      const motherMobile = getVal(["mother's mobile", "mother mobile", "mother phone", "mother's phone", "mother contact"]);

      return {
        ...student,
        extra_details: extra,
        form_title: formName,
        branch_name: branchName,
        course_name: courseName,
        father_name: fatherName,
        father_mobile: fatherMobile,
        mother_name: motherName,
        mother_mobile: motherMobile
      };
    });
  };

  fetchStudents = async () => {
    const { formId } = this.props;
    const { currentPage, pageSize, searchQuery, selectedBranches, selectedStatus, selectedTimeframe, startDate, endDate } = this.state;

    if (selectedBranches.length === 0 || selectedStatus.length === 0) {
      this.setState({
        students: [],
        totalRecords: 0,
        totalCompleted: 0,
        totalAssigned: 0,
        totalAdmitted: 0,
        loader: false,
      });
      return;
    }

    const maxStatusCount = this.state.hasExams ? STATUS_OPTIONS.length : 2;
    const statusToSend = selectedStatus.length === maxStatusCount ? [] : selectedStatus.map(s => s.value);

    this.setState({ loader: true, error: "" });

    const variables = {
      form_ids: this.state.selectedFormIds.map(f => parseInt(f.value)),
      page: currentPage,
      limit: pageSize,
      search: searchQuery || "",
      branch_ids: selectedBranches.map(b => String(b.value)),
      status: statusToSend,
    };
    if (selectedTimeframe.value >= 0) {
      variables.days = selectedTimeframe.value;
    }
    if (selectedTimeframe.value === -1) {
      if (startDate) variables.startDate = startDate;
      if (endDate)   variables.endDate   = endDate;
    }

    try {
      const result = await this.props.client.query({
        query: GET_PAGINATED_ENQUIRY_SUBMISSIONS,
        variables,
        fetchPolicy: "network-only",
      });

      const paginatedData = result.data.getPaginatedEnquirySubmissions;
      const submissions = paginatedData ? paginatedData.submissions : [];

      const studentsWithDetails = await this.processSubmissions(submissions);

      this.setState({
        students: studentsWithDetails, // Backend already sorted by ID DESC
        totalRecords: paginatedData ? paginatedData.totalCount : 0,
        totalCompleted: paginatedData ? paginatedData.totalCompleted : 0,
        totalAssigned: paginatedData ? paginatedData.totalAssigned : 0,
        totalAdmitted: paginatedData ? paginatedData.totalAdmitted : 0,
        loader: false,
      });
    } catch (err) {
      console.error("Error fetching submissions:", err);
      this.setState({
        loader: false,
        error: "Failed to load registered students. Please try again.",
      });
    }
  };

  downloadExcel = async () => {
    this.setState({ exporting: true });
    const students = await this.fetchAllFilteredStudents();

    const data = students.map((s, idx) => {
      const row = {
        "S.No": idx + 1,
        "Registration Date": this.formatDate(s.inserted_at),
        "Student Name": s.student_name,
        "Mobile": s.student_mobile,
        "Email": s.student_email || "—",
        "Form Name": s.form_title || "—",
        "Branch": s.branch_name,
        "Enquiry Class": s.course_name || "—",
        "Status": s.is_admitted === 1 ? "Admitted" : s.test_status || "Enquired",
        "Test Score": s.test_score !== null ? `${s.test_score}/${s.total_marks}` : "—",
      };

      // Add common extra details if they exist
      if (s.extra_details) {
        Object.entries(s.extra_details).forEach(([key, val]) => {
          if (!["student_name", "student_mobile", "student_email", "branch_id", "enquiry_course_id"].includes(key.toLowerCase().replace(/ /g, '_'))) {
            row[key] = val;
          }
        });
      }
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Students");

    const formName = this.props.stateData?.form_name || "Enquiry";
    XLSX.writeFile(wb, `${formName.replace(/ /g, '_')}_Registrations_${new Date().toLocaleDateString()}.xlsx`);
    this.setState({ exporting: false });
  };

  printData = async () => {
    this.setState({ printing: true });
    const students = await this.fetchAllFilteredStudents();

    const formName = this.props.stateData?.form_name || "Enquiry Form";
    const rows = students.map((s, idx) => `
      <tr>
        <td>${idx + 1}</td>
        <td>${this.formatDate(s.inserted_at)}</td>
        <td><strong>${s.student_name}</strong></td>
        <td>${s.student_mobile}</td>
        <td>${s.form_title || "—"}</td>
        <td>${s.branch_name}</td>
        <td>${s.course_name || "—"}</td>
        <td>${s.is_admitted === 1 ? "Admitted" : s.test_status || "Enquired"}</td>
      </tr>
    `).join("");

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>${formName} Registrations</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 30px; color: #333; }
            h2 { color: #213046; margin-bottom: 5px; }
            p { color: #666; margin-top: 0; margin-bottom: 25px; font-size: 14px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th { background-color: #f8fafc; color: #475569; font-weight: 600; text-align: left; padding: 12px 15px; border-bottom: 2px solid #e2e8f0; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; }
            td { padding: 12px 15px; border-bottom: 1px solid #e2e8f0; font-size: 14px; }
            tr:nth-child(even) { background-color: #fcfcfc; }
            .status-admitted { color: #16a34a; font-weight: 600; }
            @media print {
              body { padding: 0; }
              @page { margin: 1cm; }
            }
          </style>
        </head>
        <body>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 25px; border-bottom: 3px solid #213046; padding-bottom: 20px;">
            <div style="display: flex; align-items: center; gap: 20px;">
              <img src="https://support.rizee.in/files/stdomnic1.png" alt="Institute Logo" style="height: 100px; object-fit: contain;" />
              <div>
                <h2 style="margin: 0; color: #0f172a; font-family: 'Cinzel', serif;">ST. DOMINIC'S COLLEGE</h2>
                <p style="margin: 4px 0; font-size: 13px; color: #475569;">Plot No: 45, Academic Avenue, Educational District, State - 500001</p>
                <p style="margin: 4px 0; font-size: 13px; color: #475569;"><strong>Email:</strong> registrar@stdominic.edu | <strong>Contact:</strong> +91 999 888 7777</p>
              </div>
            </div>
            <div style="text-align: right;">
              <h3 style="margin: 0; color: #213046; font-size: 18px;">${formName} - Registrations</h3>
              <p style="margin: 5px 0 0 0; font-size: 12px; color: #64748b;">Generated on: ${new Date().toLocaleString()} | Total Records: ${students.length}</p>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Student Name</th>
                <th>Mobile</th>
                <th>Form</th>
                <th>Branch</th>
                <th>Class</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
      this.setState({ printing: false });
    }, 500);
  };

  printIndividualStudent = async (student) => {
    // Parse the submission's custom values (keyed by field_name).
    let rawDetails = {};
    try {
      if (student.extra_details) {
        rawDetails = typeof student.extra_details === 'string'
          ? JSON.parse(student.extra_details)
          : student.extra_details;
      }
    } catch (e) {
      console.warn("Failed to parse extra_details", e);
    }

    // Fetch the form's fields in their saved order so the print mirrors the form.
    let formFields = [];
    try {
      const { data } = await this.props.client.query({
        query: GET_FORM_FIELDS_FOR_PRINT,
        variables: {
          form_id: parseInt(student.enquiry_form_id),
          institute_id: parseInt(Cookies.get("institutionid")) || undefined,
        },
        fetchPolicy: "network-only",
      });
      formFields = (data.getEnquiryFormFields || [])
        .slice()
        // Email is not shown by default.
        .filter((f) => f.field_key !== "student_email" && !(f.field_name || "").toLowerCase().includes("email"))
        .sort((a, b) => (a.order_no || 0) - (b.order_no || 0));
    } catch (e) {
      console.warn("Failed to fetch form fields for print", e);
    }

    const MASTER_KEYS = ["student_name", "student_mobile", "student_email", "dob", "gender", "enquiry_course_id"];
    const masterValue = (key) => {
      switch (key) {
        case "student_name": return student.student_name;
        case "student_mobile": return student.student_mobile;
        case "student_email": return student.student_email;
        case "dob": return this.formatDate(student.dob);
        case "gender": return student.gender;
        case "enquiry_course_id": return student.course_name || student.enquiry_courses;
        default: return null;
      }
    };

    // Build the ordered list of { label, value } from the form fields.
    const rows = formFields.map((f) => {
      let val = (f.field_key && MASTER_KEYS.includes(f.field_key))
        ? masterValue(f.field_key)
        : rawDetails[f.field_name];
      if (Array.isArray(val)) val = val.join(", ");
      return {
        label: f.field_name,
        value: (val === undefined || val === null || String(val).trim() === "") ? "" : String(val),
      };
    });

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>ENQUIRY_FORM_${student.id}</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
            @page { size: A4; margin: 10mm; }
            body { font-family: 'Inter', sans-serif; margin: 0; padding: 0; color: #000; background: #fff; }
            .form-wrapper { width: 100%; max-width: 210mm; margin: 0 auto; padding: 16px; box-sizing: border-box; }
            .header-table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
            .inst-name { font-size: 28px; font-weight: 800; text-transform: uppercase; margin: 0; }
            .inst-sub { font-size: 13px; font-weight: 600; margin: 2px 0; }
            .form-tag { background: #000; color: #fff; padding: 5px 20px; font-weight: 800; font-size: 16px; margin-top: 8px; display: inline-block; }
            .detail-table { width: 100%; border-collapse: collapse; }
            .detail-table td { border: 1px solid #000; padding: 8px 10px; vertical-align: top; font-size: 13px; }
            .detail-table td.label { width: 45%; font-weight: 600; }
            .detail-table td.value { font-weight: 700; }
            @media print { .no-print { display: none; } }
          </style>
        </head>
        <body>
          <div class="form-wrapper">
            <table class="header-table">
              <tr>
                <td style="width: 100px;"><img src="https://support.rizee.in/files/stdomnic1.png" style="width: 90px;" alt="Logo" /></td>
                <td style="text-align: center;">
                  <h1 class="inst-name">ST. DOMINIC'S COLLEGE</h1>
                  <p class="inst-sub">Recognized by Govt. of Telangana | Affiliated to O.U.</p>
                  <p class="inst-sub">Plot 45, Academic Avenue, Hyderabad - 500001</p>
                  <div class="form-tag">ENQUIRY FORM</div>
                </td>
                <td style="width: 100px; text-align: right; vertical-align: top;">
                  <div style="border: 2px solid #000; padding: 5px; font-weight: 800; font-size: 11px;">ENQUIRY NO:<br>#${student.id}</div>
                </td>
              </tr>
            </table>

            <table class="detail-table">
              ${rows.map((r, i) => `
                <tr>
                  <td class="label">${i + 1}. ${r.label}</td>
                  <td class="value">${r.value}</td>
                </tr>
              `).join('')}
            </table>

          </div>
          <button class="no-print" onclick="window.print()" style="position: fixed; bottom: 30px; right: 30px; background: #000; color: #fff; border: none; padding: 15px 30px; cursor: pointer; font-weight: 800; box-shadow: 0 4px 12px rgba(0,0,0,0.3);">PRINT NOW</button>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  handleSearch = (e) => {
    this.setState({ searchQuery: e.target.value, currentPage: 1 }, () => this.fetchStudents());
  };

  handleBranchChange = (selected) => {
    this.setState({ selectedBranches: selected, currentPage: 1, selectedFormIds: [] }, () => this.fetchForms(selected));
  };

  // Single-select branch dropdown (same style as the Admission List branch filter).
  // "" = All Branches → selects every branch; otherwise just the chosen one.
  // selectedBranches stays an array so the rest of the query flow is unchanged.
  handleBranchSelectChange = (e) => {
    const val = e.target.value;
    const branchOptions = (this.props.globals?.globalBranches || [])
      .map((b) => ({ label: b.branch_name, value: b.id }));
    const selected = val === ""
      ? branchOptions
      : branchOptions.filter((b) => String(b.value) === String(val));
    this.handleBranchChange(selected);
  };

  handleFormsChange = (selected) => {
    this.setState({ selectedFormIds: selected, currentPage: 1 }, () => this.fetchStudents());
  };

  handleStatusChange = (selected) => {
    this.setState({ selectedStatus: selected, currentPage: 1 }, () => this.fetchStudents());
  };

  handleTimeframeChange = (e) => {
    const val = parseInt(e.target.value);
    const selected = TIMEFRAME_OPTIONS.find(o => o.value === val);
    this.setState({ selectedTimeframe: selected, currentPage: 1 }, () => {
      if (val !== -1) {
        this.fetchStudents();
      }
    });
  };

  handleDateChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, currentPage: 1 }, () => {
      if (this.state.startDate && this.state.endDate) {
        this.fetchStudents();
      }
    });
  };

  handleDateBlockApply = (startDate, endDate) => {
    const customOption = TIMEFRAME_OPTIONS.find(o => o.value === -1);
    this.setState({
      selectedTimeframe: customOption,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate:   endDate.format("YYYY-MM-DD"),
      currentPage: 1,
    }, () => this.fetchStudents());
  };

  clearDateFilter = () => {
    const custom = TIMEFRAME_OPTIONS.find(o => o.value === -1);
    const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    const today = fmt(new Date());
    const weekAgoDate = new Date();
    weekAgoDate.setDate(weekAgoDate.getDate() - 7);
    const weekAgo = fmt(weekAgoDate);
    this.setState({
      selectedTimeframe: custom,
      startDate: weekAgo,
      endDate: today,
      currentPage: 1,
    }, () => this.fetchStudents());
  };


  openAssignModal = (student) => {
    this.setState({
      showAssignModal: true,
      selectedStudent: {
        id: student.id,
        student_name: student.student_name,
        student_mobile: student.student_mobile,
        branch_id: student.branch_id,
      },
    });
  };

  closeAssignModal = () => {
    this.setState({ showAssignModal: false, selectedStudent: null });
    // Refresh data after closing
    this.fetchStudents();
  };

  openDetailModal = (student) => {
    this.setState({ showDetailModal: true, detailStudent: student });
  };

  closeDetailModal = () => {
    this.setState({ showDetailModal: false, detailStudent: null });
  };

  openSMSModal = (student) => {
    this.setState({ showSMSModal: true, smsStudent: student });
  };

  closeSMSModal = () => {
    this.setState({ showSMSModal: false, smsStudent: null });
  };

  openEmailModal = (student) => {
    this.setState({ showEmailModal: true, emailStudent: student });
  };

  closeEmailModal = () => {
    this.setState({ showEmailModal: false, emailStudent: null });
  };

  openWAModal = (student) => {
    this.setState({ showWAModal: true, waStudent: student });
  };

  closeWAModal = () => {
    this.setState({ showWAModal: false, waStudent: null });
  };

  openResultModal = async (student) => {
    this.setState({ showResultModal: true, resultStudent: student, loadingResult: true, resultSessionData: null });

    try {
      const response = await this.props.client.query({
        query: GET_ADMISSION_TEST_SESSION,
        variables: {
          enquiry_form_master_id: parseInt(student.enquiry_form_master_id || student.id), // Ensure correct mapping
          admission_test_id: parseInt(student.admission_test_id)
        },
        fetchPolicy: 'network-only'
      });

      const sessionData = response.data.getAdmissionTestSession;
      this.setState({ resultSessionData: sessionData, loadingResult: false });
    } catch (error) {
      console.error("Failed to fetch detailed result", error);
      this.setState({ loadingResult: false });
    }
  };

  closeResultModal = () => {
    this.setState({ showResultModal: false, resultStudent: null, resultSessionData: null });
  };



  handleMarkAdmitted = (student) => {
    this.setState({
      showAdmitModal: true,
      admitStudent: student
    });
  };

  onAdmissionSuccess = async () => {
    const { admitStudent } = this.state;
    // Refresh students to reflect changes
    await this.fetchStudents();

    // Automatically trigger SMS notification for admission
    triggerSms(this.props.client, {
      student: admitStudent,
      type: 'ADMITTED'
    });

    // Automatically trigger Email confirmation
    triggerEmail(this.props.client, {
      student: admitStudent,
      type: 'ADMISSION_CONFIRMED'
    });

    alert(`${admitStudent.student_name} Admitted Successfully.`);
  };

  getStatusBadge = (student) => {
    const status = (student.test_status || "").toLowerCase();
    const admittedStatus = student.admitted_status;

    if (student.is_admitted === 1) {
      return (
        <span 
          className="af-status-badge af-status-admitted" 
          style={{ cursor: "pointer", transition: "all 0.2s" }}
          onClick={() => this.handleMarkAdmitted(student)}
          title="Click to Edit Admission Form"
        >
          <i className="fas fa-graduation-cap" /> Student Admitted
        </span>
      );
    }

    if (status === "completed") {
      return (
        <span className="af-status-badge af-status-completed">
          <i className="fas fa-check-circle" /> Exam Completed
        </span>
      );
    }
    if (status === "assigned") {
      return (
        <span className="af-status-badge af-status-assigned">
          <i className="fas fa-clock" /> Exam Assigned
        </span>
      );
    }
    return (
      <span className="af-status-badge af-status-not-assigned">
        <i className="fas fa-minus-circle" /> Enquired
      </span>
    );
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "—";
    try {
      let d = new Date(dateStr);

      // Handle numeric strings (milliseconds) from backend
      if (isNaN(d.getTime()) && !isNaN(Number(dateStr))) {
        d = new Date(Number(dateStr));
      }

      if (isNaN(d.getTime())) return dateStr;

      return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  handleSelectAll = (e, paginatedStudents) => {
    if (e.target.checked) {
      const allIds = paginatedStudents
        .filter(s => s.is_admitted !== 1)
        .map(s => s.id);
      this.setState({ selectedStudentIds: allIds });
    } else {
      this.setState({ selectedStudentIds: [] });
    }
  };

  handleSelectRow = (e, studentId) => {
    const { selectedStudentIds } = this.state;
    if (e.target.checked) {
      this.setState({ selectedStudentIds: [...selectedStudentIds, studentId] });
    } else {
      this.setState({ selectedStudentIds: selectedStudentIds.filter(id => id !== studentId) });
    }
  };

  handleBulkAssign = async () => {
    const { selectedStudentIds, students } = this.state;
    const { formId } = this.props;

    // Filter students to ensure they don't already have an assigned test or are admitted
    const eligibleStudents = students.filter(s =>
      selectedStudentIds.includes(s.id) &&
      !s.test_status &&
      s.is_admitted !== 1
    );

    if (eligibleStudents.length === 0) {
      alert("None of the selected students are eligible for test assignment.");
      return;
    }

    if (!window.confirm(`Are you sure you want to assign tests to ${eligibleStudents.length} students?`)) return;

    this.setState({ bulkAssigning: true });
    try {
      // Use the first student's branch as the target branch or you can group by branch.
      // For simplicity, we assume they are filtered by one branch or we pass "all" 
      const branchIdToUse = eligibleStudents[0].branch_id || "all";
      const instId = eligibleStudents[0].institute_id;

      await this.props.client.mutate({
        mutation: ASSIGN_ADMISSION_TESTS_BULK,
        variables: {
          enquiry_form_master_ids: eligibleStudents.map(s => parseInt(s.id)),
          institute_id: parseInt(instId),
          branch_id: String(branchIdToUse),
          inserted_by: null
        }
      });

      alert(`Successfully assigned tests to ${eligibleStudents.length} students.`);
      this.setState({ selectedStudentIds: [] });
      this.fetchStudents();
    } catch (err) {
      console.error(err);
      alert(err.message || "Bulk assign failed.");
    }
    this.setState({ bulkAssigning: false });
  };

  handleBulkAdmit = () => {
    const { selectedStudentIds, students } = this.state;
    const eligibleStudents = students.filter(s =>
      selectedStudentIds.includes(s.id) &&
      s.is_admitted !== 1
    );

    if (eligibleStudents.length === 0) {
      alert("None of the selected students are eligible for admission (must not be already admitted).");
      return;
    }

    this.setState({ showBulkAdmitModal: true });
  };

  onBulkAdmissionSuccess = () => {
    this.setState({ selectedStudentIds: [], showBulkAdmitModal: false });
    this.fetchStudents();
  };

  render() {
    const {
      loader,
      error,
      searchQuery,
      selectedBranches,
      showAssignModal,
      selectedStudent,
      showDetailModal,
      detailStudent,
      students,
      currentPage,
      pageSize,
      totalRecords,
      totalCompleted,
      totalAssigned,
      totalAdmitted,
      showSMSModal,
      smsStudent,
      showEmailModal,
      emailStudent,
      showWAModal,
      waStudent,
      showResultModal,
      resultStudent,
      resultSessionData,
      loadingResult,
      selectedTimeframe,
      selectedStatus,
      startDate,
      endDate,
      printing,
      exporting,
      selectedStudentIds,
      bulkAssigning,
      selectedFormIds,
      availableForms
    } = this.state;

    const { stateData, globals } = this.props;
    const formName = stateData?.form_name || "Enquiry Form";

    // Pagination Logic
    const effectivePageSize = pageSize === -1 ? totalRecords : pageSize;
    const totalPages = effectivePageSize > 0 ? Math.ceil(totalRecords / effectivePageSize) : 1;
    let paginatedStudents = students;

    let authorizedIds = [];
    try {
      const cookie = Cookies.get("branch_id");
      const parsed = cookie ? JSON.parse(cookie) : [];
      authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      try {
        const cookie = Cookies.get("branch_id");
        authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
      } catch (err) { console.error(err); }
    }
    authorizedIds = authorizedIds.map(String);

    const branchOptions = (globals?.globalBranches || [])
      .map(b => ({
        label: b.branch_name,
        value: b.id
      }));

    const { hasExams } = this.state;
    const finalStatusOptions = hasExams ? STATUS_OPTIONS : STATUS_OPTIONS.filter(o => o.value === "admitted" || o.value === "");

    return (
      <Container fluid className="px-0 pb-5">
        {/* Removed Breadcrumbs for tab view */}

        <div className="af-admin-header mt-0 mb-4 pb-3 border-bottom d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center" style={{ gap: "20px" }}>
          <div>
            <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
              <i className="fas fa-users-cog mr-2 text-primary opacity-75" />
              Enquiry  Data
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
              View and manage registered students and their test statuses across all forms.
            </p>
          </div>

          {/* KPI Cards — Dashboard Style */}
          <div className="af-kpi-metrics-row d-flex align-items-center" style={{ gap: "16px" }}>
            <div className="af-kpi-card shadow-sm">
              <div className="af-kpi-icon-wrap bg-primary-subtle text-primary">
                <i className="fas fa-users" />
              </div>
              <div className="af-kpi-info">
                <div className="af-kpi-val">{totalRecords}</div>
                <div className="af-kpi-lbl">Total Students</div>
              </div>
            </div>
            {hasExams && (
              <>
                <div className="af-kpi-card shadow-sm">
                  <div className="af-kpi-icon-wrap bg-success-subtle text-success">
                    <i className="fas fa-check-double" />
                  </div>
                  <div className="af-kpi-info">
                    <div className="af-kpi-val text-success">{totalCompleted}</div>
                    <div className="af-kpi-lbl">Exams Completed</div>
                  </div>
                </div>
                <div className="af-kpi-card shadow-sm">
                  <div className="af-kpi-icon-wrap bg-warning-subtle text-warning">
                    <i className="fas fa-hourglass-half" />
                  </div>
                  <div className="af-kpi-info">
                    <div className="af-kpi-val text-warning">{totalAssigned}</div>
                    <div className="af-kpi-lbl">Exams Assigned</div>
                  </div>
                </div>
              </>
            )}
            <div className="af-kpi-card shadow-sm">
              <div className="af-kpi-icon-wrap bg-info-subtle text-info">
                <i className="fas fa-graduation-cap" />
              </div>
              <div className="af-kpi-info">
                <div className="af-kpi-val text-info">{totalAdmitted}</div>
                <div className="af-kpi-lbl">Student Admitted</div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Date range + Export/Print (kept above the filters) ── */}
        <div className="af-results-filter-bar af-enq-toolbar-row mb-3" style={{ position: "relative", zIndex: 100 }}>
          <Row className="justify-content-end align-items-center" style={{ rowGap: "16px" }}>
            <Col xs="auto" className="ml-auto mb-2 mb-xl-0">
              <div className="adm-enq-daterange" style={{ width: 210, maxWidth: "100%" }}>
                <DateBlock
                  applyCallback={this.handleDateBlockApply}
                  initialStart={(() => {
                    if (startDate) return startDate;
                    const d = new Date();
                    if (selectedTimeframe.value > 0) d.setDate(d.getDate() - selectedTimeframe.value);
                    if (selectedTimeframe.value === 2) d.setDate(new Date().getDate() - 1);
                    const y = d.getFullYear();
                    const m = String(d.getMonth() + 1).padStart(2, "0");
                    const day = String(d.getDate()).padStart(2, "0");
                    return `${y}-${m}-${day}`;
                  })()}
                  initialEnd={(() => {
                    if (endDate) return endDate;
                    const d = new Date();
                    if (selectedTimeframe.value === 2) d.setDate(d.getDate() - 1);
                    const y = d.getFullYear();
                    const m = String(d.getMonth() + 1).padStart(2, "0");
                    const day = String(d.getDate()).padStart(2, "0");
                    return `${y}-${m}-${day}`;
                  })()}
                />
              </div>
            </Col>
            <Col xs="auto" className="mb-2 mb-xl-0">
              <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                <Button
                  variant="outline-success"
                  size="sm"
                  className="font-weight-bold d-flex align-items-center"
                  style={{ height: '40px', borderRadius: '8px', border: '1px solid #16a34a', color: '#16a34a', background: 'transparent' }}
                  onClick={this.downloadExcel}
                  disabled={exporting}
                >
                  {exporting ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-file-excel mr-2" />}
                  Excel
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="font-weight-bold d-flex align-items-center"
                  style={{ height: '40px', borderRadius: '8px', border: '1px solid #475569', color: '#475569', background: 'transparent' }}
                  onClick={this.printData}
                  disabled={printing}
                >
                  {printing ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-print mr-2" />}
                  Print
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        {/* ── Filter Bar ── */}
        <div className="af-results-filter-bar mb-4" style={{ position: "relative", zIndex: 1 }}>
          <Row className="justify-content-start align-items-center" style={{ rowGap: "16px" }}>
            <Col xs="auto" className="mb-2 mb-xl-0">
              <div className="af-search-input-wrap shadow-sm" style={{ width: 240, maxWidth: "100%" }}>
                <div className="af-search-icon-bg">
                  <i className="fas fa-search af-search-icon" />
                </div>
                <input
                  type="text"
                  className="af-search-input"
                  placeholder="Search student..."
                  value={searchQuery}
                  onChange={this.handleSearch}
                />
                {searchQuery && (
                  <button className="af-search-clear" onClick={() => this.setState({ searchQuery: "", currentPage: 1 }, this.fetchStudents)}>
                    <i className="fas fa-times-circle" />
                  </button>
                )}
              </div>
            </Col>
            {/* No Branch filter — the header (NavbarOne) scopes this tab. */}
            <Col xs="auto" className="mb-2 mb-xl-0">
              <div className="af-dash-multiselect" style={{ width: 200, maxWidth: "100%" }}>
                <MultiSelect
                  options={availableForms}
                  value={selectedFormIds}
                  onChange={this.handleFormsChange}
                  labelledBy="Forms"
                  overrideStrings={{
                    selectSomeItems: "All Forms",
                    allItemsAreSelected: "All Forms"
                  }}
                />
              </div>
            </Col>
            <Col xs="auto" className="mb-2 mb-xl-0">
              <div className="af-dash-multiselect" style={{ width: 190, maxWidth: "100%" }}>
                <MultiSelect
                  options={finalStatusOptions}
                  value={selectedStatus}
                  onChange={this.handleStatusChange}
                  labelledBy="Exam Status"
                  overrideStrings={{
                    selectSomeItems: "Filter by Status",
                    allItemsAreSelected: "All Statuses"
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* ── Bulk Actions Toolbar ── */}
        {selectedStudentIds.length > 0 && (
          <div className="af-bulk-actions-bar mb-3 p-3 bg-white border rounded shadow-sm d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <Badge variant="primary" className="mr-3 px-3 py-2" style={{ fontSize: '14px', borderRadius: '20px' }}>
                {selectedStudentIds.length} Selected
              </Badge>
              <span className="text-muted small font-weight-bold">Apply to selected:</span>
            </div>
            <div className="d-flex" style={{ gap: '10px' }}>
              {hasExams && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="font-weight-bold"
                  onClick={this.handleBulkAssign}
                  disabled={bulkAssigning}
                >
                  {bulkAssigning ? <Spinner size="sm" animation="border" /> : <><i className="fas fa-tasks mr-1"></i> Assign Test</>}
                </Button>
              )}
              <Button
                variant="outline-success"
                size="sm"
                className="font-weight-bold"
                onClick={this.handleBulkAdmit}
                disabled={bulkAssigning}
              >
                <i className="fas fa-user-check mr-1"></i> Admit Selected
              </Button>
              <Button
                variant="light"
                size="sm"
                className="border font-weight-bold text-muted"
                onClick={() => this.setState({ selectedStudentIds: [] })}
              >
                Clear
              </Button>
            </div>
          </div>
        )}

        {/* ── Content Area ── */}
        <div className="af-content-card shadow-sm">
          {loader ? (
            <div className="table-responsive">
              <table className="table af-skeleton-table mb-0">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}><span className="af-skeleton-box w-100"></span></th>
                    <th><span className="af-skeleton-box"></span></th>
                    <th><span className="af-skeleton-box"></span></th>
                    <th><span className="af-skeleton-box"></span></th>
                    <th><span className="af-skeleton-box mx-auto"></span></th>
                    <th className="text-center"><span className="af-skeleton-box w-75 mx-auto"></span></th>
                    <th className="text-center"><span className="af-skeleton-box w-75 mx-auto"></span></th>
                    <th className="text-right" style={{ paddingRight: "24px" }}><span className="af-skeleton-box w-50 ml-auto"></span></th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5].map((i) => (
                    <tr key={i}>
                      <td><span className="af-skeleton-box af-sk-sub w-100"></span></td>
                      <td>
                        <span className="af-skeleton-box af-sk-title"></span>
                        <span className="af-skeleton-box af-sk-sub"></span>
                      </td>
                      <td><span className="af-skeleton-box af-sk-title"></span></td>
                      <td>
                        <span className="af-skeleton-box af-sk-title"></span>
                        <span className="af-skeleton-box af-sk-sub"></span>
                      </td>
                      <td><span className="af-skeleton-box af-sk-title"></span></td>
                      <td className="text-center"><span className="af-skeleton-box af-sk-badge mx-auto"></span></td>
                      <td className="text-center"><span className="af-skeleton-box af-sk-title mx-auto"></span></td>
                      <td className="text-right">
                        <span className="af-skeleton-box af-sk-action"></span>
                        <span className="af-skeleton-box af-sk-action"></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : error ? (
            <div className="af-error-container py-5">
              <i className="fas fa-exclamation-circle text-danger mb-3" style={{ fontSize: "32px" }} />
              <h5>Connection Error</h5>
              <p className="text-muted">{error}</p>
              <button className="btn btn-outline-primary btn-sm mt-2" onClick={this.fetchStudents}>Try Again</button>
            </div>
          ) : paginatedStudents.length === 0 ? (
            <div className="af-empty-container py-5 text-center">
              <div className="af-empty-icon-wrap mb-3">
                <i className="fas fa-user-friends text-muted opacity-25" style={{ fontSize: "56px" }} />
              </div>
              <h5>No Students Found</h5>
              <p className="text-muted mx-auto" style={{ maxWidth: "400px" }}>
                {searchQuery || selectedBranches.length < branchOptions.length
                  ? "We couldn't find any students matching your current filters. Try adjusting your search term or branch selection."
                  : "No students have registered using this form yet."}
              </p>
              {(searchQuery || selectedBranches.length < branchOptions.length) && (
                <button className="btn btn-link text-primary mt-2" onClick={() => this.setState({ searchQuery: "", selectedBranches: branchOptions, currentPage: 1 }, this.fetchStudents)}>
                  Clear all filters
                </button>
              )}
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table af-modern-table mb-0">
                <thead>
                  <tr>
                    <th style={{ width: "40px" }} className="text-center">
                      <Form.Check
                        type="checkbox"
                        checked={paginatedStudents.length > 0 && paginatedStudents.filter(s => s.is_admitted !== 1).length > 0 && this.state.selectedStudentIds.length === paginatedStudents.filter(s => s.is_admitted !== 1).length}
                        onChange={(e) => this.handleSelectAll(e, paginatedStudents)}
                        disabled={paginatedStudents.filter(s => s.is_admitted !== 1).length === 0}
                      />
                    </th>
                    <th style={{ width: "60px" }}>#</th>
                    <th>Student Name</th>
                    <th>Primary Contact Number</th>
                    <th>Parent Details</th>
                    <th>Form Name</th>
                    <th>Details</th>
                    <th>Date Registered</th>
                    <th className="text-center">Status</th>
                    {hasExams && <th className="text-center">Result</th>}
                    <th className="text-right" style={{ paddingRight: "24px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedStudents.map((student, index) => {
                    const absoluteIndex = (currentPage - 1) * effectivePageSize + index + 1;
                    return (
                      <tr key={student.id || index} className={this.state.selectedStudentIds.includes(student.id) ? "bg-light" : ""}>
                        <td className="text-center align-middle">
                          <Form.Check
                            type="checkbox"
                            checked={this.state.selectedStudentIds.includes(student.id)}
                            onChange={(e) => this.handleSelectRow(e, student.id)}
                            disabled={student.is_admitted === 1}
                          />
                        </td>
                        <td className="text-muted" style={{ fontSize: "12px" }}>{absoluteIndex.toString().padStart(2, '0')}</td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="af-student-primary-name" onClick={() => this.openDetailModal(student)}>
                              {student.student_name || "—"}
                            </span>
                            <span className="af-student-sub-text">ID: #{student.id}</span>
                          </div>
                        </td>
                        <td>
                          <a
                            href={`tel:${student.student_mobile}`}
                            className="af-phone-wrap"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            title="Click to call"
                          >
                            <i className="fas fa-phone-alt mr-2 opacity-40" />
                            {student.student_mobile || "—"}
                          </a>
                        </td>
                        <td>
                          <div className="d-flex flex-column" style={{ fontSize: "12px" }}>
                            <span className="text-truncate" style={{ maxWidth: "160px" }} title={student.father_name}>
                              <strong>F:</strong> {student.father_name !== "—" ? student.father_name : "N/A"}
                            </span>
                            <span className="text-muted" style={{ fontSize: "11px" }}>
                              <strong>M:</strong> {student.mother_name !== "—" ? student.mother_name : "N/A"} | <i className="fas fa-phone-alt opacity-50 ml-1 mr-1"/> {student.mother_mobile !== "—" ? student.mother_mobile : "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="text-truncate" style={{ maxWidth: "160px", fontSize: "13px" }} title={student.form_title}>
                              {student.form_title || "—"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
                            <span className="text-truncate" style={{ maxWidth: "160px" }} title={student.student_email}>
                              {student.student_email || "—"}
                            </span>
                            <span className="text-muted" style={{ fontSize: "11px" }}>{student.gender || "—"} | {this.formatDate(student.dob)}</span>
                          </div>
                        </td>
                        <td className="text-muted">{this.formatDate(student.inserted_at)}</td>
                        <td className="text-center">
                          {this.getStatusBadge(student)}
                        </td>
                        {hasExams && (
                          <td className="text-center">
                            {(student.test_status || "").toLowerCase() === "completed" ? (
                              <div className="af-score-pill cursor-pointer hover-bg-light" onClick={() => this.openResultModal(student)}>
                                <span className="af-score-val">{student.test_score ?? "—"}</span>
                                <span className="af-score-max">/ {student.total_marks || "300"}</span>
                              </div>
                            ) : (
                              <span className="text-muted opacity-40">—</span>
                            )}
                          </td>
                        )}

                        <td className="text-right">
                          <div className="af-actions-flex justify-content-end">
                            {hasExams && !(student.test_status) && student.is_admitted !== 1 && (
                              <button
                                className="af-action-pill-btn"
                                onClick={() => this.openAssignModal(student)}
                              >
                                Assign Test
                              </button>
                            )}
                            {student.is_admitted !== 1 && (
                              <button
                                className="af-action-pill-btn admit-btn"
                                onClick={() => this.handleMarkAdmitted(student)}
                              >
                                <i className="fas fa-user-check mr-1" /> Admit
                              </button>
                            )}

                            <OverlayTrigger placement="top" overlay={<Tooltip id={`view-t-${student.id}`}>View Details</Tooltip>}>
                              <button
                                className="af-action-icon-btn view-btn"
                                onClick={() => this.openDetailModal(student)}
                              >
                                <i className="fas fa-eye" />
                              </button>
                            </OverlayTrigger>


                            <OverlayTrigger placement="top" overlay={<Tooltip id={`print-ind-t-${student.id}`}>Print Form</Tooltip>}>
                              <button
                                className="af-action-icon-btn print-btn"
                                onClick={() => this.printIndividualStudent(student)}
                                style={{ color: '#0f172a' }}
                              >
                                <i className="fas fa-print" />
                              </button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {/* Pagination Footer - Premium Numbered Style */}
              {(totalRecords > 0) && (
                <div className="af-pagination-footer-sticky px-4 py-3 border-top d-flex justify-content-between align-items-center bg-white shadow-sm">
                  
                  {/* Bottom Left: Per Page */}
                  <div className="d-inline-flex align-items-center bg-white border px-3 py-1 rounded shadow-sm" style={{ height: '40px' }}>
                    <span className="small text-muted font-weight-bold mr-2 text-uppercase">Per Page:</span>
                    <Form.Control
                      as="select"
                      size="sm"
                      className="border-0 shadow-none font-weight-bold p-0"
                      value={pageSize}
                      onChange={this.handlePageSizeChange}
                      style={{ width: '70px', height: '100%', cursor: 'pointer', color: '#0f172a', background: 'transparent' }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={-1}>All</option>
                    </Form.Control>
                  </div>

                  {/* Center: Pagination Controls */}
                  {pageSize !== -1 && totalPages > 1 && (
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      <Button
                        variant="light"
                        size="sm"
                        className="af-pag-btn af-pag-nav"
                        disabled={currentPage === 1}
                        onClick={() => this.setState({ currentPage: currentPage - 1 }, () => this.fetchStudents())}
                      >
                        <i className="fas fa-chevron-left" />
                      </Button>

                      {(() => {
                        const pages = [];
                        const showMax = 5;
                        let start = Math.max(1, currentPage - 2);
                        let end = Math.min(totalPages, start + showMax - 1);
                        if (end - start + 1 < showMax) {
                          start = Math.max(1, end - showMax + 1);
                        }

                        if (start > 1) {
                          pages.push(
                            <Button key={1} variant="light" size="sm" className="af-pag-btn" onClick={() => this.setState({ currentPage: 1 }, () => this.fetchStudents())}>1</Button>
                          );
                          if (start > 2) pages.push(<span key="dots-start" className="px-1 text-muted">...</span>);
                        }

                        for (let i = start; i <= end; i++) {
                          pages.push(
                            <Button
                              key={i}
                              variant={currentPage === i ? "primary" : "light"}
                              size="sm"
                              className={`af-pag-btn ${currentPage === i ? 'active shadow-sm' : ''}`}
                              onClick={() => this.setState({ currentPage: i }, () => this.fetchStudents())}
                            >
                              {i}
                            </Button>
                          );
                        }

                        if (end < totalPages) {
                          if (end < totalPages - 1) pages.push(<span key="dots-end" className="px-1 text-muted">...</span>);
                          pages.push(
                            <Button key={totalPages} variant="light" size="sm" className="af-pag-btn" onClick={() => this.setState({ currentPage: totalPages }, () => this.fetchStudents())}>{totalPages}</Button>
                          );
                        }
                        return pages;
                      })()}

                      <Button
                        variant="light"
                        size="sm"
                        className="af-pag-btn af-pag-nav"
                        disabled={currentPage === totalPages}
                        onClick={() => this.setState({ currentPage: currentPage + 1 }, () => this.fetchStudents())}
                      >
                        <i className="fas fa-chevron-right" />
                      </Button>
                    </div>
                  )}

                  {/* Bottom Right: Showing Reports */}
                  <div className="small font-weight-bold text-muted">
                    Showing <span className="text-dark">{(currentPage - 1) * effectivePageSize + 1}</span> to <span className="text-dark">{Math.min(currentPage * effectivePageSize, totalRecords)}</span> of <span className="text-dark">{totalRecords}</span> reports
                  </div>

                </div>
              )}
            </div>
          )}
        </div>

        <style>{`
           .af-pagination-footer-sticky {
              position: sticky;
              bottom: 0;
              z-index: 100;
              background-color: white !important;
              box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.05);
           }
           .af-pag-btn {
              min-width: 32px;
              height: 32px;
              padding: 0 8px;
              border-radius: 6px;
              font-weight: 600;
              font-size: 13px;
              border: 1px solid #e2e8f0;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s;
           }
           .af-pag-btn.active {
              background-color: #2563eb !important;
              border-color: #2563eb !important;
              color: white !important;
           }
           .af-pag-nav {
              background-color: #f8fafc;
           }
           .af-pag-close {
              height: 32px;
              border-radius: 6px;
              font-size: 13px;
           }
           .af-modern-table thead th {
              background: #f8fafc;
              border-top: none;
              color: #64748b;
              font-size: 11px;
              text-transform: uppercase;
              letter-spacing: 1px;
              padding: 16px 12px;
              position: sticky;
              top: 0;
              z-index: 50;
              box-shadow: 0 1px 0 #e2e8f0;
           }
           .af-modern-table tbody tr:hover {
              background-color: rgba(99, 102, 241, 0.02);
           }
           .hover-text-primary:hover { color: #6366f1 !important; }
           .hover-bg-light:hover:not(:disabled) { background: #f1f5f9; }
           
           .af-kpi-card {
              background: #fff;
              border: 1px solid #e2e8f0;
              padding: 16px;
              border-radius: 12px;
              display: flex;
              align-items: center;
              gap: 16px;
              flex: 1;
              min-width: 180px;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
           }
           .af-kpi-card:hover {
              transform: translateY(-4px);
              box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
              border-color: #cbd5e1;
           }
           .af-kpi-icon-wrap {
              width: 48px;
              height: 48px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              flex-shrink: 0;
           }
           .af-kpi-info {
              display: flex;
              flex-direction: column;
           }
           .af-kpi-val { font-size: 22px; font-weight: 800; line-height: 1.2; }
           .af-kpi-lbl { font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; margin-top: 2px; }
           .af-results-filter-bar {
              position: relative;
              z-index: 110; /* Higher than table header (50) and bulk bar (100) */
              background: #fff;
              padding: 16px;
              border: 1px solid #e2e8f0;
              border-radius: 12px;
              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
           }
           
           .af-bulk-actions-bar {
              position: relative;
              z-index: 105;
           }
        `}</style>

        {/* ── Modals ── */}
        <AssignTestModal
          show={showAssignModal}
          onHide={this.closeAssignModal}
          student={selectedStudent}
        />

        <DynamicAdmissionModal
          show={this.state.showAdmitModal}
          onHide={() => this.setState({ showAdmitModal: false, admitStudent: null })}
          student={this.state.admitStudent}
          onSuccess={this.onAdmissionSuccess}
        />

        <BulkAdmitModal
          show={this.state.showBulkAdmitModal}
          onHide={() => this.setState({ showBulkAdmitModal: false })}
          students={students.filter(s => this.state.selectedStudentIds.includes(s.id))}
          onSuccess={this.onBulkAdmissionSuccess}
        />

        <SendSMSModal
          show={this.state.showSMSModal}
          onHide={this.closeSMSModal}
          student={this.state.smsStudent}
        />

        <SendEmailModal
          show={this.state.showEmailModal}
          onHide={this.closeEmailModal}
          student={this.state.emailStudent}
        />

        <SendWhatsAppModal
          show={this.state.showWAModal}
          onHide={this.closeWAModal}
          student={this.state.waStudent}
        />

        <StudentProfileModal
          show={showDetailModal}
          onHide={this.closeDetailModal}
          student={detailStudent}
          hasExams={hasExams}
          client={this.props.client}
          formId={this.props.formId}
          onUpdate={this.fetchStudents}
          branches={this.props.globals?.globalBranches || []}
        />

        <Modal show={showResultModal} onHide={this.closeResultModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Detailed Result Report</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: '#f8f9fa' }}>
            {loadingResult ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3 text-muted">Loading subject-wise analytics...</p>
              </div>
            ) : resultSessionData ? (
              <AdmissionDetailedResultPdf
                studentName={resultStudent?.student_name}
                totalMarks={resultSessionData.total_marks || resultStudent?.total_marks}
                marksGained={resultSessionData.total_marks_gained || resultStudent?.test_score}
                subjectAnalytics={resultSessionData.subject_analytics}
                testName="Admission Test"
              />
            ) : (
              <div className="alert alert-warning text-center">
                Could not load detailed results for this student.
              </div>
            )}
          </Modal.Body>
        </Modal>

      </Container>
    );
  }
}

export default withRouter(withApollo(AllEnquiryStudentsTab));
